import {useMutation} from '@tanstack/react-query';
import {useSnackbar} from 'notistack';

import {issueImpersonationToken} from '../api';

// Issues a fresh token on every call — it's short-lived (3h) and meant to be
// used right away for QA/support guest-login, not cached or reused.
export const useIssueImpersonationToken = () => {
  const {enqueueSnackbar} = useSnackbar();

  return useMutation({
    mutationFn: (userId: string) => issueImpersonationToken(userId),
    onError: error => {
      enqueueSnackbar(error.message, {
        variant: 'error',
      });
    },
  });
};
